import Vue from "vue";
import VueI18n from "vue-i18n";
import zh_cn from "./zh-CN.json";
import us_en from "./us-EN.json";
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: localStorage.getItem('333f-locale-lang') || "zh_cn", // 语言标识
    messages: {
        zh_cn, // 中文语言包
        us_en, // 英文语言包
    },
    // 去除警告
    // silentTranslationWarn: true,
});
export { i18n };


// WEBPACK FOOTER //
// ./src/locale/index.js